/* tslint:disable */

export const faCircle: any = {"prefix":"fas","iconName":"circle","icon":[512,512,[],"f111","M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"]};